<body>
<div class="wrapper">
  <div class="container">
    <div class="row">
      <div class="col-sm-10 m-auto">
        <div class="login-logo mb-3" *ngIf="order.accountOwnerLogo">
          <a href="{{order.accountOwnerWebsite}}" target="_blank">
            <img alt="logo" class="img-fluid" height="120" src="{{order.accountOwnerLogo}}" width="120"></a>
        </div>
        <div *ngIf="!order.accountOwnerLogo" class="label mb-3">
          <label>{{order.accountOwnerCompany}}</label>
        </div>
      </div>

      <div class="row" *ngIf="trackingMenuList?.length > 0">
        <div class="col">
          <div class="topnav">
            <a *ngFor="let trackMenu of trackingMenuList ; let i = index;" style="color:white"
               href="{{trackMenu.menuUrl}}" target="_blank">{{trackMenu.menuName}}&nbsp;&nbsp;<span
              *ngIf="i !== trackingMenuList.length-1"> | </span> &nbsp;&nbsp; </a>
          </div>
        </div>
      </div>
      <div class="row mt-2" *ngIf="track1.webBanner != null">
        <div class="col">
          <a>
            <img alt="{{track1.altText || 'no banner'}}" class="img-fluid" height="120" src="{{track1.webBanner}}"
                 width="120"></a>
        </div>
      </div>

      <div class="branded-sec-btn py-4 mt-5 clearfix ">
        <a (click)="submitOtp('cancel')"
           *ngIf="order?.orderStatus != 'DELIVERED' && order?.orderStatus != 'COMPLETED'"
           class="icon-left link-blue-primary float-end">
          <svg fill="none" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.59732 5.3966L5.40265 8.59127M8.59831 8.5932L5.40098 5.3952M9.88998 0.833466H4.11065C2.09665 0.833466 0.833984 2.25947 0.833984 4.27747V9.7228C0.833984 11.7408 2.09065 13.1668 4.11065 13.1668H9.88932C11.91 13.1668 13.1673 11.7408 13.1673 9.7228V4.27747C13.1673 2.25947 11.91 0.833466 9.88998 0.833466Z"
              stroke="#2196F3" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
          </svg>
          Request for Cancellation
        </a>
        <!--(click)="submitOtp('return')"-->
        <a (click)="navigate()"
           *ngIf="order?.orderStatus == 'DELIVERED' || order?.orderStatus == 'COMPLETED'"
           class="icon-left link-blue-primary float-end">
          <svg fill="none" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.59732 5.3966L5.40265 8.59127M8.59831 8.5932L5.40098 5.3952M9.88998 0.833466H4.11065C2.09665 0.833466 0.833984 2.25947 0.833984 4.27747V9.7228C0.833984 11.7408 2.09065 13.1668 4.11065 13.1668H9.88932C11.91 13.1668 13.1673 11.7408 13.1673 9.7228V4.27747C13.1673 2.25947 11.91 0.833466 9.88998 0.833466Z"
              stroke="#2196F3" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
          </svg>
          Request for Return
        </a>
      </div>
      <div class="branded-sec pb-4">
        <div class="row">
          <div class="col-lg-4 col-md-6 delivery">
            <div class="white-box">
              <div class="box-head">
                <div class="row">
                  <div class="col-sm-12">
                    <h6 class="heading-bold" *ngIf="status != 'DELIVERED' && status != 'CANCELLED'">Estimated Delivery Date</h6>
                    <h6 class="heading-bold" *ngIf="status === 'DELIVERED'">Order Delivered On</h6>
                    <h6 class="heading-bold" *ngIf="status === 'CANCELLED'">Order Cancelled On</h6>
                  </div>
                </div>
              </div>

              <div class="date-sec">
                <p class="text-center link-black">{{estimatedDelivery | date : "EEEE"}}</p>
                <h2 class="text-center link-orange-primary">{{estimatedDelivery | date : "MMMM"}}</h2>
                <h4 class="text-center link-orange-primary">{{estimatedDelivery | date : "d"}}</h4>
                <span class="badge bg-orange-primary">{{order?.orderStatus}}</span>
                <h3 class="link-blue-primary text-center mb-2">Shipped By -
                  {{(order?.shippingOption == 'SD' ? 'Shift' :
                  (order?.shippingOption == 'DL' ? 'Delhivery' :
                  (order?.shippingOption == 'GT' ? 'Gati' :
                  (order?.shippingOption == 'DZ' ? 'Dotzot' :
                  (order?.shippingOption == 'RD' ? 'Rapid Delivery' :
                  (order?.shippingOption == 'SF' ? 'Shadow Fax' :
                  (order?.shippingOption == 'BD' ? 'Blue Dart' :
                  (order?.shippingOption == 'PR' ? 'Pickrr' :
                  (order?.shippingOption == 'SY' ? 'Ship Yaari' :
                  (order?.shippingOption == 'DE' ? 'Delhivery' :
                  (order?.shippingOption == 'SG' ? 'Shippigo' :
                  (order?.shippingOption == 'VS' ? 'Vamaship' :
                  (order?.shippingOption == 'DN' ? 'Dunzo' :
                  (order?.shippingOption == 'WF' ? 'Borzo' :
                  (order?.shippingOption == 'UE' ? 'UdaanExpress' :
                  (order?.shippingOption == 'FE' ? 'FedEx' : order?.shippingOption))))))))))))))))}} </h3>
                <h3 class="link-blue-primary text-center">Tracking ID - {{order?.trackingNumbers}}</h3>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="white-box " style="float:left;height: 423px;overflow-y: auto;">
              <div class="box-head">
                <div class="row">
                  <div class="col-sm-12">
                    <h6 class="heading-bold">Track Order</h6>
                  </div>
                </div>
              </div>
              <div class="tracklist">
                <ul>
                  <li *ngFor="let t of getTrackOrderData">
                      <span
                        [ngClass]="{'bg-blue-secondary':t.status === 'SUBMITTED','bg-green':t.status === 'DELIVERED' || t.status === 'COMPLETED','bg-purple':t.status !== 'DELIVERED' && t.status !=='SUBMITTED' && t.status !=='COMPLETED'}"
                        class="badge">
                    {{(t.status == 'SUBMITTED' ? 'Order Placed' :
                     t.status | replaceStatus)}}</span>
                    <p>{{t.activityDate}}</p>
                    <p>{{t.description}}</p>
                  </li>
                  <a type="button" data-bs-toggle="collapse" data-bs-target="#carrierData"
                     class="badge bg-orange-primary">Carrier Details</a>
                  <li id="carrierData" class="collapse" *ngFor="let t of getCarrierTrackOrderData">
                      <span
                        [ngClass]="{'bg-blue-secondary':t.status === 'SUBMITTED','bg-green':t.status === 'DELIVERED' || t.status === 'COMPLETED','bg-purple':t.status !== 'DELIVERED' && t.status !=='SUBMITTED' && t.status !=='COMPLETED'}"
                        class="badge">
                    {{t.carrierStatus}}</span>
                    <p>{{t.carrierActivityDate}}</p>
                    <p>{{t.carrierDescription}}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-12">
            <div class="white-box additional-info mt-0 order-shiping-info" style="height:423px;">
              <div class="box-head">
                <div class="row">
                  <div class="col-sm-12">
                    <h6 class="heading-bold">Order Details</h6>
                  </div>
                </div>
              </div>
              <div class="box-body">
                <div class="row">
                  <div class="col-md-6">
                    <label>Order#</label>
                    <p>{{order?.orderNumber}}</p>
                  </div>
                  <div class="col-md-6">
                    <label>Order Date</label>
                    <p>{{order?.createdDate}}</p>
                  </div>
                  <div *ngIf="order?.sourceOrderId !== null" class="col-md-6">
                    <label>Source Order#</label>
                    <p>{{order?.sourceOrderId}}</p>
                  </div>
                  <div class="col-md-6">
                    <label>Name of the Buyer</label>
                    <p>{{order?.receiverName}}</p>
                  </div>
                  <div class="col-md-6">
                    <label>Phone Number</label>
                    <p>{{order?.receiverMobile}}</p>
                  </div>
                  <div class="col-md-12">
                    <label>Address</label>
                    <p>{{order?.receiverAddressText}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</body>


<div [ngClass]="{'modal': needActionPopup == 'Y'}" [ngStyle]="{'display': needActionPopup =='Y'? 'block' : 'none'}"
     aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal" id="needActionPopUp" role="dialog"
     style="overflow-y:auto" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="needActionLabe">Return to Order</h5>
        <button (click)="closeRequestPoup()" aria-label="Close" class="close" type="button">
          <svg height="33" id="close-icon" viewBox="0 0 33 33" width="33" xmlns="http://www.w3.org/2000/svg">
            <g data-name="Close-Icon" id="Close-Icon-2" transform="translate(16.263 0) rotate(45)">
              <path d="M1,0V22" data-name="Line 4" fill="none" id="Line_4" stroke="#979797"
                    stroke-linecap="square" stroke-miterlimit="10" stroke-width="1" transform="translate(10.5 0.5)"/>
              <path d="M0,1H22" data-name="Line 6" fill="none" id="Line_6" stroke="#979797"
                    stroke-linecap="square" stroke-miterlimit="10" stroke-width="1" transform="translate(0.5 10.5)"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row">
            <div class="col">
              <label class="control-label" for="cancelReason">Reason</label>
              <select [(ngModel)]="needActionReason" [ngModelOptions]="{standalone: true}" class="form-control"
                      id="cancelReason" required>
                <option *ngFor="let c of actionReasons" [ngValue]="c.config">{{c.label}}</option>
              </select>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <label class="control-label" for="description">Notes</label>
              <textarea [(ngModel)]="actionInstructions" [ngModelOptions]="{standalone: true}"
                        class="form-control textbox"
                        id="description"
                        required rows="6"></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-right">
              <button (click)="closeRequestPoup()" class="btn btn-cancel ml-1" type="submit">Cancel</button>
              <button class="btn btn-orange2 ml-1" type="submit">Request RTO</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->

<div [ngClass]="{'modal': ReattemptRequestPopup == 'Y'}"
     [ngStyle]="{'display': ReattemptRequestPopup =='Y'? 'block' : 'none'}"
     aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal" id="ReattemptRequestPopup"
     role="dialog"
     style="overflow-y:auto" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="ReattemptRequest">Reattempt Request</h5>
        <button (click)="closeRequestPoup()" aria-label="Close" class="close" type="button">
          <svg height="33" id="close-icon" viewBox="0 0 33 33" width="33" xmlns="http://www.w3.org/2000/svg">
            <g data-name="Close-Icon" id="Close-Icon-2" transform="translate(16.263 0) rotate(45)">
              <path d="M1,0V22" data-name="Line 4" fill="none" id="Line_4" stroke="#979797"
                    stroke-linecap="square" stroke-miterlimit="10" stroke-width="1" transform="translate(10.5 0.5)"/>
              <path d="M0,1H22" data-name="Line 6" fill="none" id="Line_6" stroke="#979797"
                    stroke-linecap="square" stroke-miterlimit="10" stroke-width="1" transform="translate(0.5 10.5)"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>

          <div class="row mt-2">
            <div class="col">
              <div class="inner-box">
                <h2 class="text-black"><b>Customer Details</b></h2>
                <div class="row mt-3">
                  <div class="col-lg-4 col-sm-6">
                    <label class="text-black">{{viewCustomer?.ownerName | titlecase}}</label>
                    <label class="text-black">{{viewCustomer?.email}}</label>
                    <label class="text-black">{{viewCustomer?.mobile}}</label>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div *ngFor="let add of viewCustomer.adddressList" class="row mt-3">
            <div class="col">
              <div class="inner-box">
                <h2 class="text-black"><b>Current Address & Delivery</b></h2>
                <div class="row mt-3">
                  <div class="col-md-6">
                    <label class="text-black">{{add.addressType | titlecase}}</label><br>
                    <label class="text-black">{{add.address1}}</label><br>
                    <label class="text-black">{{add.address2}}</label><br>
                    <label class="text-black">{{add.city}}</label><br>
                    <label class="text-black">{{add.state}}</label><br>
                    <label class="text-black">{{add.zip}}</label><br>
                    <label class="text-black"><b>Date</b> : 25-10-2021</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col">
              <label class="control-label">Notes</label>
              <textarea [(ngModel)]="actionInstructions" [ngModelOptions]="{standalone: true}"
                        class="form-control textbox"
                        id="descriptionR"
                        required rows="6"></textarea>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-12 text-right">
              <button (click)="closeRequestPoup()" class="btn btn-cancel ml-1" type="submit">Cancel</button>
              <button class="btn btn-orange2 ml-1" type="submit">Request</button>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>


<div [ngClass]="{'modal': escalatePopup == 'Y'}" [ngStyle]="{'display': escalatePopup =='Y'? 'block' : 'none'}"
     aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal" id="escalatePopup" role="dialog"
     style="overflow-y:auto" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <button (click)="closeRequestPoup()" aria-label="Close" class="close" type="button">
          <svg height="33" id="close-icon" viewBox="0 0 33 33" width="33" xmlns="http://www.w3.org/2000/svg">
            <g data-name="Close-Icon" id="Close-Icon-2" transform="translate(16.263 0) rotate(45)">
              <path d="M1,0V22" data-name="Line 4" fill="none" id="Line_4" stroke="#979797"
                    stroke-linecap="square" stroke-miterlimit="10" stroke-width="1" transform="translate(10.5 0.5)"/>
              <path d="M0,1H22" data-name="Line 6" fill="none" id="Line_6" stroke="#979797"
                    stroke-linecap="square" stroke-miterlimit="10" stroke-width="1" transform="translate(0.5 10.5)"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-2">
            <div class="col-md-6">
              <label class="control-label">Notes</label>
              <textarea [(ngModel)]="actionInstructions" [ngModelOptions]="{standalone: true}"
                        class="form-control textbox"
                        id="descriptionE"
                        required rows="6"></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-right">
              <button (click)="closeRequestPoup()" class="btn btn-cancel ml-1" type="submit">Cancel</button>
              <button class="btn btn-orange2 ml-1" type="submit">Submit</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


<div [ngClass]="{'modal': otpPopUp == 'Y'}" [ngStyle]="{'display': otpPopUp =='Y'? 'block' : 'none'}"
     aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal" id="otpPopUp" role="dialog"
     style="overflow-y:auto" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <button (click)="closeOtpPopup()" aria-label="Close" class="close" type="button">
          <svg height="33" id="close-icon" viewBox="0 0 33 33" width="33" xmlns="http://www.w3.org/2000/svg">
            <g data-name="Close-Icon" id="Close-Icon-2" transform="translate(16.263 0) rotate(45)">
              <path d="M1,0V22" data-name="Line 4" fill="none" id="Line_4" stroke="#979797"
                    stroke-linecap="square" stroke-miterlimit="10" stroke-width="1" transform="translate(10.5 0.5)"/>
              <path d="M0,1H22" data-name="Line 6" fill="none" id="Line_6" stroke="#979797"
                    stroke-linecap="square" stroke-miterlimit="10" stroke-width="1" transform="translate(0.5 10.5)"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form class="otp-section">
          <h2>Enter the OTP sent to {{str}}.</h2>
          <div class="row mt-4">
            <div class="col-3"><input (keyup)="keytab($event, 'password2', 'password1')" [(ngModel)]="password1"
                                      [ngClass]="{'is-invalid':errorMessage}"
                                      [ngModelOptions]="{standalone: true}" appOnlyNumbers autofocus="autofocus"
                                      class="form-control text-center" id="password1" maxlength="1"
                                      required type="number"></div>
            <div class="col-3"><input (keyup)="keytab($event, 'password3', 'password1')" [(ngModel)]="password2"
                                      [ngClass]="{'is-invalid':errorMessage}"
                                      [ngModelOptions]="{standalone: true}" appOnlyNumbers
                                      class="form-control text-center"
                                      id="password2" maxlength="1"
                                      required type="number"></div>
            <div class="col-3"><input (keyup)="keytab($event, 'password4', 'password2')" [(ngModel)]="password3"
                                      [ngClass]="{'is-invalid':errorMessage}"
                                      [ngModelOptions]="{standalone: true}" appOnlyNumbers
                                      class="form-control text-center"
                                      id="password3" maxlength="1"
                                      required type="number"></div>
            <div class="col-3"><input (keyup)="keytab($event, 'password4', 'password3');verifyOtp()"
                                      [(ngModel)]="password4"
                                      [ngClass]="{'is-invalid':errorMessage}" [ngModelOptions]="{standalone: true}"
                                      appOnlyNumbers class="form-control text-center"
                                      id="password4" maxlength="1"
                                      required type="number"></div>
          </div>
          <div [hidden]="!errorMessage" class="invalid-feedback d-block mb-3">{{errorMessage}}</div>
          <div [hidden]="!successMessage" class="text-success invalid-feedback d-block mb-3">{{successMessage}}</div>
          <div class="row align-items-center mb-4 mt-3">
            <div class="offset-md-3 col-md-6">
              <button (click)="verifyOtp()" class="btn btn-orange-prime btn-block">Verify</button>
            </div>
          </div>

          <div class="text-orange mt-5">
            OTP expires in {{timerDisplayValue}} Minutes!
          </div>
          <div class="mt-2 forgot">
            <a (click)="submitResend()">Resend OTP</a>
          </div>

        </form>

      </div>
    </div>
  </div>
</div>


<div [ngClass]="{'modal': returnPopUp == 'Y'}" [ngStyle]="{'display': returnPopUp =='Y'? 'block' : 'none'}"
     aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal" id="returnPopUp" role="dialog"
     style="overflow-y:auto" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <button (click)="returnPopUpClose()" aria-label="Close" class="close" type="button">
          <svg height="33" id="close-icon" viewBox="0 0 33 33" width="33" xmlns="http://www.w3.org/2000/svg">
            <g data-name="Close-Icon" id="Close-Icon-2" transform="translate(16.263 0) rotate(45)">
              <path d="M1,0V22" data-name="Line 4" fill="none" id="Line_4" stroke="#979797"
                    stroke-linecap="square" stroke-miterlimit="10" stroke-width="1" transform="translate(10.5 0.5)"/>
              <path d="M0,1H22" data-name="Line 6" fill="none" id="Line_6" stroke="#979797"
                    stroke-linecap="square" stroke-miterlimit="10" stroke-width="1" transform="translate(0.5 10.5)"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">

        <form>
          <div class="row mt-3">
            <div class="col">
              <label class="control-label" for="returnReason">Return Reason</label>
              <select [(ngModel)]="reason" [ngModelOptions]="{standalone: true}" class="form-control"
                      id="returnReason" required>
                <option *ngFor="let r of returnReasons" [ngValue]="r.config">{{r.config}}</option>
              </select>
              <div [hidden]="!reasonError" class="invalid-feedback d-block shift-invalid-login">
                {{reasonError}}
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12 text-right">
              <button (click)="returnPopUpClose()" class="btn btn-cancel ml-1" type="submit">Cancel</button>
              <button (click)="submitReturnOrder()" class="btn btn-orange2 ml-1" type="submit">Submit</button>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>
</div>

<div [ngClass]="{'modal': cancelPopUp == 'Y'}" [ngStyle]="{'display': cancelPopUp =='Y'? 'block' : 'none'}"
     aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal" id="cancelPop" role="dialog"
     style="overflow-y:auto"
     tabindex="-1" value="cancel">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <button (click)="cancelPopUpClose()" aria-label="Close" class="close" type="button">
          <svg height="33" id="close-icon" viewBox="0 0 33 33" width="33" xmlns="http://www.w3.org/2000/svg">
            <g data-name="Close-Icon" id="Close-Icon-2" transform="translate(16.263 0) rotate(45)">
              <path d="M1,0V22" data-name="Line 4" fill="none" id="Line_4" stroke="#979797"
                    stroke-linecap="square" stroke-miterlimit="10" stroke-width="1" transform="translate(10.5 0.5)"/>
              <path d="M0,1H22" data-name="Line 6" fill="none" id="Line_6" stroke="#979797"
                    stroke-linecap="square" stroke-miterlimit="10" stroke-width="1" transform="translate(0.5 10.5)"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col">
              <label class="control-label" for="cancelReason">Cancel Reason</label>
              <select [(ngModel)]="cancelReason" [ngModelOptions]="{standalone: true}" class="form-control"
                      id="cancelReason2" required>
                <option *ngFor="let cancel of cancelReasons" [ngValue]="cancel.config">{{cancel.config}}</option>
              </select>
              <div [hidden]="!cancelReasonError" class="invalid-feedback d-block shift-invalid-login">
                {{cancelReasonError}}
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12 text-right">
              <button (click)="cancelPopUpClose()" class="btn btn-cancel ml-1" type="submit">Cancel</button>
              <button (click)="submitCancelOrder()" class="btn btn-orange2 ml-1" type="submit">Submit</button>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>
</div>
